import { api } from "../intreceptor/apiInterceptor";

export interface Comment {
  id: string;
  comment: string;
  createdAt: string;
  updatedAt: string | null;
  userId: {
    id: string;
    name: string;
    email: string;
    mobileNumber: string;
    status: string;
    createdAt: string;
    updatedAt: string;
    refreshToken: string;
    lastLogin: string;
    lastLogout: string;
  };
  jobId: {
    id: string;
    jobSiteName: string;
    subsite: string;
    siteContact: string;
    status: string;
    markAsComp: boolean;
    createdAt: string;
    updatedAt: string;
    isSubmitted: boolean;
    isDeleted: boolean;
    deletedAt: string | null;
    deletionReason: string | null;
  };
}

export interface GetCommentsResponse extends Array<Comment> {}

export interface CreateCommentRequest {
  comment: string;
  userId: string;
  jobId: string;
}

export interface CreateCommentResponse {
  comment: string;
  jobId: {
    id: string;
  };
  userId: {
    id: string;
  };
  id: string;
  createdAt: string;
}

export const CommentsService = {
  async getCommentsByJobId(jobId: string): Promise<GetCommentsResponse> {
    try {
      const response = await api.fetch<any>(`/comments/getComments/${jobId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      // Ensure response is an array and transform each comment
      if (Array.isArray(response)) {
        return response.map(comment => ({
          id: comment.id || '',
          comment: comment.comment || '',
          createdAt: comment.createdAt || new Date().toISOString(),
          updatedAt: comment.updatedAt,
          userId: {
            id: comment.userId?.id || '',
            name: comment.userId?.name || '',
            email: comment.userId?.email || '',
            mobileNumber: comment.userId?.mobileNumber || '',
            status: comment.userId?.status || '',
            createdAt: comment.userId?.createdAt || '',
            updatedAt: comment.userId?.updatedAt || '',
            refreshToken: comment.userId?.refreshToken || '',
            lastLogin: comment.userId?.lastLogin || '',
            lastLogout: comment.userId?.lastLogout || ''
          },
          jobId: {
            id: comment.jobId?.id || '',
            jobSiteName: comment.jobId?.jobSiteName || '',
            subsite: comment.jobId?.subsite || '',
            siteContact: comment.jobId?.siteContact || '',
            status: comment.jobId?.status || '',
            markAsComp: comment.jobId?.markAsComp || false,
            createdAt: comment.jobId?.createdAt || '',
            updatedAt: comment.jobId?.updatedAt || '',
            isSubmitted: comment.jobId?.isSubmitted || false,
            isDeleted: comment.jobId?.isDeleted || false,
            deletedAt: comment.jobId?.deletedAt,
            deletionReason: comment.jobId?.deletionReason
          }
        }));
      }
      return [];
    } catch (error) {
      console.error('Error fetching comments:', error);
      return [];
    }
  },

  async createComment(data: CreateCommentRequest): Promise<CreateCommentResponse> {
    try {
      
      const response = await api.fetch<CreateCommentResponse>('/comments/create', {
        method: 'POST',
        body: JSON.stringify(data),
      });
      
      return response;
    } catch (error) {
      console.error('Error creating comment:', error);
      throw error;
    }
  }
};
